export type SelectOption = {
  label: string;
  value: string;
};
export enum InspectionStatusEnum {
  All = 'ALL',
  Completed = 'COMPLETED',
  Submitting = 'SUBMITTING',
  Submitted = 'SUBMITTED',
  Initiated = 'INITIATED',
  InProgress = 'IN_PROGRESS',
  RULE_BLOCKED = 'RULE_BLOCKED',
  UpdateRequired = 'UPDATE_REQUIRED',
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED'
}
export type InspectionStatusType =
  | InspectionStatusEnum.All
  | InspectionStatusEnum.Completed
  | InspectionStatusEnum.Submitting
  | InspectionStatusEnum.Submitted
  | InspectionStatusEnum.Initiated
  | InspectionStatusEnum.InProgress
  | InspectionStatusEnum.RULE_BLOCKED
  | InspectionStatusEnum.UpdateRequired
  | InspectionStatusEnum.APPROVAL_REQUIRED;
export enum UserStatusEnum {
  All = 'all',
  ACTIVE = 'Active',
  INVITATION_PENDING = 'Invitation Pending',
  INVITATION_EXPIRED = 'Invitation Expired',
  REVOKED = 'Revoked',
  REQUEST_DECLINED = 'Request Declined',
  ACCESS_REQUESTED = 'Access Requested',
  ACCESS_REQUESTED_PENDING = 'Pending',
  NOT_REQUESTED = 'Not requested'
}
export enum EmailStatusEnum {
  Drafted = 'Drafted',
  Attempted = 'Attempted',
  Deferred = 'Deferred',
  Sent = 'Sent',
  Delivered = 'Delivered',
  Opened = 'Opened',
  Clicked = 'Clicked',
  Converted = 'Converted',
  Unsubscribed = 'Unsubscribed',
  Bounced = 'Bounced',
  Dropped = 'Dropped',
  Spammed = 'Spammed',
  Failed = 'Failed',
  Undeliverable = 'Undeliverable'
}
export enum VehiclePhotosEnum {
  'ASSET_FRONT',
  'ASSET_RIGHT',
  'ASSET_LEFT',
  'ASSET_BACK'
}
export enum UserActionEnum {
  ACTIVE = 'Revoke access',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  INVITATION_PENDING = 'Revoke access',
  REVOKED = 'Reactivate'
}
export enum InspectionDocumentStatusEnum {
  Completed = 'complete',
  Incomplete = 'incomplete',
  notRequested = 'NOT_REQUESTED',
  notProvided = 'NOT_PROVIDED',
  notFound = 'NOT_FOUND',
  notPerformed = 'UNAVAILABLE',
  warning = 'WARNING',
  registrations = 'registrations',
  registered = 'registered',
  noRegister = 'UNREGISTERED',
  inprogress = 'inprogress',
  ResupplyPending = 'ResupplyPending',
  RecentlyPaidOutFinance = 'RecentlyPaidOutFinance'
}

export enum InspectionSecurityStatusEnum {
  notRequested = 'NOT_REQUESTED',
  notFound = 'NOT_FOUND',
  notPerformed = 'UNAVAILABLE',
  notAvailable = 'NOT_AVAILABLE',
  notProvided = 'NOT_PROVIDED',
  warning = 'WARNING',
  pass = 'PASS',
  failed = 'FAIL',
  registrations = 'registrations',
  expired = 'REGISTRATION_EXPIRED',
  registered = 'registered',
  noRegister = 'UNREGISTERED',
  reportFound = 'RECORD_FOUND',
  noReport = 'NO_REPORT',
  noRecord = 'NO_RECORD',
  match = 'MATCH',
  discrepancyFound = 'DIFFERENT',
  error = 'ERROR',
  authenticityWarning = 'AUTHENTICITY_WARNING',
  ocrFailed = 'OCR_FAIL',
  incorrectDocumentType = 'INCORRECT_DOCUMENT_TYPE',
  inprogress = 'inprogress',
  ResupplyPending = 'ResupplyPending',
  RecentlyPaidOutFinance = 'RecentlyPaidOutFinance',
  criteriaNotMet = 'CRITERIA_NOT_MET'
}

export enum InspectionSecurityCheckAIPhotosTypeEnum {
  VEHICLE_PHOTOS_QUALITY = 'VEHICLE_PHOTOS_QUALITY',
  VEHICLE_PHOTOS_AUTHENTICITY = 'VEHICLE_PHOTOS_AUTHENTICITY'
}

export const AIPHOTOS_CHECK_TYPES = [
  InspectionSecurityCheckAIPhotosTypeEnum.VEHICLE_PHOTOS_QUALITY,
  InspectionSecurityCheckAIPhotosTypeEnum.VEHICLE_PHOTOS_AUTHENTICITY
];

export const SECURITY_CHECK_TYPE_TO_RULE_TYPE: Record<string, string> = {
  VEHICLE_PHOTOS_QUALITY: 'ASSET_PHOTOS_QUALITY',
  VEHICLE_PHOTOS_AUTHENTICITY: 'ASSET_PHOTOS_AUTHENTICITY',
  VEHICLE_VIN: 'ASSET_VIN_REGO_MATCH',
  REGO_EXPIRY: 'REGO_CERTIFICATE_EXPIRY_MATCH',
  REGO_CERTIFICATE: 'REGO_CERTIFICATE_AUTHENTICITY',
  LICENSE_EXPIRY: 'ID_EXPIRY',
  LICENSE_FACE_MATCH: 'ID_FACE_MATCH',
  LICENSE_LIVENESS: 'ID_LIVENESS',
  LICENSE_AUTHENTICITY: 'ID_AUTHENTICITY',
  PPSR_ENCUMBRANCE: 'ASSET_PPSR_ENCUMBRANCE',
  MARINE_PPSR_ENCUMBRANCE: 'ASSET_PPSR_ENCUMBRANCE',
  NEVDIS_STOLEN: 'ASSET_STOLEN',
  NEVDIS_WRITTEN_OFF: 'ASSET_WRITTEN_OFF',
  NEVDIS_REGISTRATION: 'ASSET_REGISTRATION',
  BANK_STATEMENT: 'BANK_STATEMENT_AUTHENTICITY',
  BANK_STATEMENT_ADDRESS: 'BANK_STATEMENT_ADDRESS_MATCH',
  licenseExpiry: 'ID_EXPIRY',
  licenseFaceMatch: 'ID_FACE_MATCH',
  licenseLiveness: 'ID_LIVENESS',
  licenseAuthenticity: 'ID_AUTHENTICITY',
  ppsr: 'ASSET_PPSR_ENCUMBRANCE',
  stolen: 'ASSET_STOLEN',
  writtenOff: 'ASSET_WRITTEN_OFF',
  registration: 'ASSET_REGISTRATION',
  vin: 'ASSET_VIN_REGO_MATCH',
  vehiclePhotosQuality: 'ASSET_PHOTOS_QUALITY',
  vehiclePhotosAuthenticity: 'ASSET_PHOTOS_AUTHENTICITY',
  expiry: 'REGO_CERTIFICATE_EXPIRY_MATCH',
  registrationAuthenticity: 'REGO_CERTIFICATE_AUTHENTICITY',
  bankAuthenticity: 'BANK_STATEMENT_AUTHENTICITY'
};

export const SECURITY_CHECK_RULE_TYPE_ALIASES: Record<string, string[]> = {};

export const REGO_CERTIFICATE_DATA_EDIT_TYPE = 'REGO_CERTIFICATE_DATA_EDIT';
export const BANK_STATEMENT_DATA_EDIT_TYPE = 'BANK_STATEMENT_DATA_EDIT';

export interface InspectionRule {
  status?: string;
  evaluation?: string;
  ruleType?: string;
  exception?: string;
}

export enum InspectionDocumentLabelStatusEnum {
  complete = 'Complete',
  incomplete = 'Incomplete',
  inprogress = 'in Progress',
  notfound = 'Not found',
  NOT_PROVIDED = 'Not Provided',
  ResupplyPending = 'Resupply Pending',
  RecentlyPaidOutFinance = 'Recently Paid Out Finance'
}
export enum InspectionCardTypeEnum {
  VehicleInfo = 'vehicleInfo',
  BuyerCard = 'buyerCard',
  SellerCard = 'sellerCard',
  LenderCard = 'lenderCard'
}

export enum AssetEnum {
  All = 'all',
  optionA = 'Car',
  optionB = 'Motor cycle',
  optionC = 'Campervan'
}
export enum AssetTypesEnum {
  CAR = 'CAR',
  CAMPERVAN = 'CARAVAN',
  TRAILER = 'TRAILER',
  MOTOR_CYCLE = 'MOTORBIKE',
  EQUIPMENT = 'EQUIPMENT',
  MARINE = 'MARINE',
  MARINE_WITH_TRAILER = 'MARINE_WITH_TRAILER'
}

export type AssetType =
  | AssetTypesEnum.CAR
  | AssetTypesEnum.CAMPERVAN
  | AssetTypesEnum.TRAILER
  | AssetTypesEnum.MOTOR_CYCLE
  | AssetTypesEnum.MARINE
  | AssetTypesEnum.EQUIPMENT
  | AssetTypesEnum.MARINE_WITH_TRAILER;
export enum LenderEnum {
  All = 'all',
  optionA = 'Maria',
  optionB = 'Steve Brewer'
}

export enum LenderStatusEnum {
  Active = 'ACTIVE',
  Pending = 'INVITATION_PENDING',
  InvitationExpired = 'INVITATION_EXPIRED',
  Revoked = 'REVOKED',
  NotRequested = 'NOT_REQUESTED',
  Declined = 'REQUEST_DECLINED',
  AccessRequested = 'ACCESS_REQUESTED',
  AccessRequestedPending = 'ACCESS_REQUESTED_PENDING'
}
export enum LenderDocumentTypeEnum {
  SELLER_ID = 'SELLER_ID',
  DRIVER_LICENCE_FRONT = 'DRIVER_LICENCE_FRONT',
  DRIVER_LICENCE_BACK = 'DRIVER_LICENCE_BACK',
  FACE = 'FACE',
  VIN = 'VIN',
  REGO_PLATE = 'REGO_PLATE',
  MARINE_HIN = 'MARINE_HIN',
  MARINE_REGO_NUMBER = 'MARINE_REGO_NUMBER',
  MARINE_REGO_CERT = 'MARINE_REGO_CERT',
  ODOMETER = 'ODOMETER',
  ASSET_FRONT = 'ASSET_FRONT',
  ASSET_BACK = 'ASSET_BACK',
  ASSET_LEFT = 'ASSET_LEFT',
  ASSET_RIGHT = 'ASSET_RIGHT',
  MARINE_FRONT = 'MARINE_FRONT',
  MARINE_BACK = 'MARINE_BACK',
  MARINE_LEFT = 'MARINE_LEFT',
  MARINE_RIGHT = 'MARINE_RIGHT',
  INTERNAL_FRONT = 'INTERNAL_FRONT',
  INTERNAL_BACK = 'INTERNAL_BACK',
  INTERNAL_BOOT = 'INTERNAL_BOOT',
  INTERNAL_LIVING_AREA = 'INTERNAL_LIVING_AREA',
  INTERNAL_KITCHEN = 'INTERNAL_KITCHEN',
  INTERNAL_SLEEPING_AREA = 'INTERNAL_SLEEPING_AREA',
  OPERATING_HOURS = 'OPERATING_HOURS',
  REGO_PAPERS = 'REGO_PAPERS',
  BANK_STATEMENTS = 'BANK_STATEMENTS',
  ROADWORTHY_CERT = 'ROADWORTHY_CERT',
  ROADWORTHY_CERT_STATE = 'ROADWORTHY_CERT_STATE',
  SAFETY_CERT = 'SAFETY_CERT',
  PAYOUT_LETTER = 'PAYOUT_LETTER',
  OWNERSHIP_PROOF = 'OWNERSHIP_PROOF',
  PPSR = 'PPSR',
  MARINE_PPSR = 'MARINE_PPSR',
  RAV = 'RAV',
  NEVDIS = 'NEVDIS',
  GLASSES = 'GLASSES',
  SALE_DETAILS = 'SALE_DETAILS'
}

export enum RoleEnum {
  ADMIN = 'ADMIN',
  STANDARD = 'STANDARD',
  LENDER = 'LENDER',
  BROKER = 'BROKER',
  LENDER_BROKER = 'LENDER_BROKER'
}

export enum CreateInspectionStepEnum {
  Lender,
  Documents,
  Seller,
  Review
}
export enum CreateInvoiceStepEnum {
  Seller,
  Buyer,
  Vehicle
}

export enum SellerPage {
  welcome,
  vehicle,
  registration,
  license,
  bank,
  cert,
  payoutLetter,
  ownershipProof,
  driverLicenseCapture,
  driverLicense,
  VIN,
  HIN,
  MarineRegoNumber,
  MarineRegoCert,
  Review,
  Plate,
  registrationDetails,
  bankDetails,
  certDetails
}
export type cardCaptureType =
  | CardCaptureStepEnum.vin
  | CardCaptureStepEnum.plateNumber
  | CardCaptureStepEnum.marineHin
  | CardCaptureStepEnum.marineRegoNumber
  | CardCaptureStepEnum.odometer
  | CardCaptureStepEnum.vehiclePhoto
  | CardCaptureStepEnum.marinePhoto
  | CardCaptureStepEnum.assetFront
  | CardCaptureStepEnum.assetLeft
  | CardCaptureStepEnum.assetBack
  | CardCaptureStepEnum.assetRight
  | CardCaptureStepEnum.marineFront
  | CardCaptureStepEnum.marineLeft
  | CardCaptureStepEnum.marineBack
  | CardCaptureStepEnum.marineRight
  | CardCaptureStepEnum.internalFront
  | CardCaptureStepEnum.internalBack
  | CardCaptureStepEnum.internalBoot
  | CardCaptureStepEnum.internalLivingArea
  | CardCaptureStepEnum.internalKitchen
  | CardCaptureStepEnum.internalSleepingArea
  | CardCaptureStepEnum.operatingHours
  | DocumentCaptureStepEnum.bank
  | DocumentCaptureStepEnum.marineRegoCert
  | DocumentCaptureStepEnum.payoutLetter
  | DocumentCaptureStepEnum.ownershipProof;
export type documentCaptureType =
  | DocumentCaptureStepEnum.bank
  | DocumentCaptureStepEnum.cert
  | DocumentCaptureStepEnum.registration
  | DocumentCaptureStepEnum.marineRegoCert
  | DocumentCaptureStepEnum.safetyCert
  | DocumentCaptureStepEnum.payoutLetter
  | DocumentCaptureStepEnum.ownershipProof;
export enum SellerPageTitle {
  Blank = '',
  vehicle = 'Vehicle',
  VIN = 'VIN',
  VinDetails = 'VIN Details',
  HIN = 'HIN',
  HinDetails = 'HIN Details',
  MarineRegoNumber = 'Registration Number',
  MarineRegoNumberDetails = 'Registration Number Details',
  MarineRegoCert = 'Registration Certificate',
  MarineRegoCertDetails = 'Registration Certificate Details',
  Review = 'Review',
  Plate = 'Number Plate',
  PlateDetails = 'Number Plate Details',
  Odometer = 'Odometer',
  OperatingHours = 'Operating Hours',
  OdometerDetails = 'Odometer Details',
  VehiclePhotos = 'Photos',
  ExternalPhotos = 'External Photos',
  InternalPhotos = 'Internal Photos',
  VehicleFrontSide = 'Front',
  VehicleFrontSeats = 'Front Seats',
  VehicleFrontDetails = 'Vehicle Front',
  VehicleBackSide = 'Back',
  VehicleBackSeats = 'Back Seats',
  VehicleBackDetails = 'Vehicle Back',
  VehicleBoot = 'Boot',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  VehicleBootDetails = 'Boot',
  VehicleLivingArea = 'Living Area',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  VehicleLivingAreaDetails = 'Living Area',
  VehicleKitchen = 'Kitchen',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  VehicleKitchenDetails = 'Kitchen',
  VehicleSleepingArea = 'Sleeping Area',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  VehicleSleepingAreaDetails = 'Sleeping Area',
  VehicleDriverSide = 'Vehicle Driver Side',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  VehicleDriverDetails = 'Vehicle Driver Side',
  VehiclePassengerSide = 'Vehicle Passenger Side',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  VehiclePassengerDetails = 'Vehicle Passenger Side',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  registration = 'Registration Certificate',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  registrationDetails = 'Registration Certificate Details',
  license = 'Licence',
  bank = 'Bank Statement',
  bankDetails = 'Bank Statement Details',
  cert = 'Roadworthy / Safety Certificate',
  certDetails = 'Roadworthy / Safety Certificate Details',
  payoutLetter = 'Payout Letter',
  payoutLetterDetails = 'Payout Letter Details',
  ownershipProof = 'Proof of ownership',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  ownershipProofDetails = 'Proof of ownership',
  safetyCert = 'Safety Certificate',
  safetyCertDetails = 'Safety Certificate Details'
}
export type SellerPageTitleType =
  | SellerPageTitle.Odometer
  | SellerPageTitle.OdometerDetails
  | SellerPageTitle.VehiclePhotos
  | SellerPageTitle.ExternalPhotos
  | SellerPageTitle.InternalPhotos
  | SellerPageTitle.VehicleFrontSide
  | SellerPageTitle.VehicleBackSide
  | SellerPageTitle.VehicleDriverSide
  | SellerPageTitle.VehiclePassengerSide
  | SellerPageTitle.VinDetails
  | SellerPageTitle.HinDetails
  | SellerPageTitle.MarineRegoNumberDetails
  | SellerPageTitle.MarineRegoCertDetails
  | SellerPageTitle.OperatingHours
  | SellerPageTitle.PlateDetails
  | SellerPageTitle.Blank
  | SellerPageTitle.vehicle
  | SellerPageTitle.registration
  | SellerPageTitle.license
  | SellerPageTitle.bank
  | SellerPageTitle.cert
  | SellerPageTitle.VIN
  | SellerPageTitle.HIN
  | SellerPageTitle.MarineRegoNumber
  | SellerPageTitle.MarineRegoCert
  | SellerPageTitle.Review
  | SellerPageTitle.Plate
  | SellerPageTitle.registrationDetails
  | SellerPageTitle.bankDetails
  | SellerPageTitle.certDetails
  | SellerPageTitle.safetyCert
  | SellerPageTitle.safetyCertDetails
  | SellerPageTitle.VehicleFrontDetails
  | SellerPageTitle.VehicleBackDetails
  | SellerPageTitle.VehicleDriverDetails
  | SellerPageTitle.VehiclePassengerDetails
  | SellerPageTitle.VehicleFrontSeats
  | SellerPageTitle.VehicleBackSeats
  | SellerPageTitle.VehicleBoot
  | SellerPageTitle.VehicleBootDetails
  | SellerPageTitle.VehicleLivingArea
  | SellerPageTitle.VehicleLivingAreaDetails
  | SellerPageTitle.VehicleKitchen
  | SellerPageTitle.VehicleKitchenDetails
  | SellerPageTitle.VehicleSleepingArea
  | SellerPageTitle.VehicleSleepingAreaDetails
  | SellerPageTitle.payoutLetter
  | SellerPageTitle.payoutLetterDetails
  | SellerPageTitle.ownershipProof
  | SellerPageTitle.ownershipProofDetails;

export type confirmModalType =
  | CardCaptureStepEnum.vin
  | CardCaptureStepEnum.plateNumber
  | CardCaptureStepEnum.marineHin
  | CardCaptureStepEnum.marineRegoNumber
  | DocumentCaptureStepEnum.bank
  | DocumentCaptureStepEnum.registration
  | DocumentCaptureStepEnum.marineRegoCert
  | DocumentCaptureStepEnum.safetyCert
  | NewInspectionModalEnum.close
  | NewInspectionModalEnum.draft
  | NewInspectionModalEnum.submit;
export enum CardCaptureStepEnum {
  sellerId = 'SELLER_ID',
  vin = 'VIN',
  plateNumber = 'REGO_PLATE',
  marineHin = 'MARINE_HIN',
  marineRegoNumber = 'MARINE_REGO_NUMBER',
  operatingHours = 'OPERATING_HOURS',
  odometer = 'ODOMETER',
  assetFront = 'ASSET_FRONT',
  assetLeft = 'ASSET_LEFT',
  assetBack = 'ASSET_BACK',
  assetRight = 'ASSET_RIGHT',
  marineFront = 'MARINE_FRONT',
  marineLeft = 'MARINE_LEFT',
  marineBack = 'MARINE_BACK',
  marineRight = 'MARINE_RIGHT',
  vehiclePhoto = 'VEHICLE_PHOTO',
  marinePhoto = 'MARINE_PHOTO',
  internalFront = 'INTERNAL_FRONT',
  internalBack = 'INTERNAL_BACK',
  internalBoot = 'INTERNAL_BOOT',
  internalLivingArea = 'INTERNAL_LIVING_AREA',
  internalKitchen = 'INTERNAL_KITCHEN',
  internalSleepingArea = 'INTERNAL_SLEEPING_AREA'
}
export enum NewInspectionModalEnum {
  close = 'close',
  draft = 'draft',
  submit = 'submit'
}
export enum DocumentCaptureStepEnum {
  registration = 'REGO_PAPERS',
  marineRegoCert = 'MARINE_REGO_CERT',
  bank = 'BANK_STATEMENTS',
  cert = 'ROADWORTHY_CERT',
  safetyCert = 'SAFETY_CERT',
  payoutLetter = 'PAYOUT_LETTER',
  ppsr = 'PPSR',
  ownershipProof = 'OWNERSHIP_PROOF'
}

export enum InspectionDriverLicenseSection {
  DRIVER_LICENCE_FRONT = 'ID Front',
  DRIVER_LICENCE_BACK = 'ID Back',
  SELLER_ID = 'Identification',
  FACE = 'Selfie',
  licenseExpiry = 'ID Expiry',
  licenseEdits = 'Data Edits',
  licenseFaceMatch = 'Face Match',
  licenseLiveness = 'Liveness',
  licenseAuthenticity = 'Authenticity'
}

export enum InspectionVehicleDetailsSection {
  rav = 'Compliance',
  ppsr = 'Financial interest (PPSR)',
  registration = 'NEVDIS Registration',
  stolen = 'Stolen Check',
  writtenOff = 'Written-off Check',
  autoGrabData = 'AutoGrab',
  vin = 'VIN & Number Plate',
  VIN = 'VIN',
  REGO_PLATE = 'Number Plate',
  MARINE_HIN = 'HIN',
  MARINE_REGO_NUMBER = 'Registration Number',
  MARINE_REGO_CERT = 'Registration Certificate',
  ODOMETER = 'Odometer',
  ASSET_FRONT = 'Vehicle Front',
  ASSET_BACK = 'Vehicle Back',
  ASSET_RIGHT = "Driver's Side",
  ASSET_LEFT = 'Passenger Side',
  INTERNAL_FRONT = 'Front Seats',
  INTERNAL_BACK = 'Back Seats',
  INTERNAL_BOOT = 'Boot',
  INTERNAL_LIVING_AREA = 'Living Area',
  INTERNAL_KITCHEN = 'Kitchen',
  INTERNAL_SLEEPING_AREA = 'Sleeping Area',
  OPERATING_HOURS = 'Operating Hours',
  MARINE_FRONT = 'Watercraft Front',
  MARINE_BACK = 'Watercraft Back',
  MARINE_LEFT = 'Port Side',
  MARINE_RIGHT = 'Starboard Side',
  SALE_DETAILS = 'Sale Price',
  vehiclePhotos = 'Photos Check',
  vehiclePhotosQuality = 'Vehicle Photos (Quality)',
  vehiclePhotosAuthenticity = 'Vehicle Photos (Authenticity)',
  dataEdits = 'Data Edits'
}

export enum InspectionRegoPapersSection {
  registration = 'Registration',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  REGO_PAPERS = 'Registration',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  MARINE_REGO_CERT = 'Registration',
  registrationAuthenticity = 'Authenticity',
  expiry = 'Match Reg. Expiry Date',
  regoCertificate = 'Data Edit'
}
export enum DocumentFormEnum {
  DETAILS_DRIVER_LICENSE_FRONT = 'DETAILS_DRIVER_LICENSE_FRONT',
  DETAILS_DRIVER_LICENSE_BACK = 'DETAILS_DRIVER_LICENSE_BACK',
  DETAILS_DRIVER_LICENSE_SELFIE = 'DETAILS_DRIVER_LICENSE_SELFIE',
  DETAILS_DRIVER_LICENSE_AUTHENTICITY = 'LICENSE_AUTHENTICITY',
  DETAILS_DRIVER_LICENSE_EXPIRY = 'LICENSE_EXPIRY',
  DETAILS_DRIVER_LICENSE_DATA_EDIT = 'LICENSE_EDITS',
  DETAILS_DRIVER_LICENSE_FACE_MATCH = 'LICENSE_FACE_MATCH',
  DETAILS_DRIVER_LICENSE_LIVENESS = 'LICENSE_LIVENESS',
  DETAILS_DRIVER_LICENSE_OFFICIAL_SOURCE = 'DETAILS_DRIVER_LICENSE_OFFICIAL_SOURCE',
  DETAILS_BANK = 'DETAILS_BANK',
  DETAILS_CERTIFICATE = 'DETAILS_CERTIFICATE',
  DETAILS_PAYOUT_LETTER = 'DETAILS_PAYOUT_LETTER',
  DETAILS_OWNERSHIP_PROOF = 'DETAILS_OWNERSHIP_PROOF',
  DETAILS_REGO_PHOTO_BACK = 'DETAILS_REGO_PHOTO_BACK',
  DETAILS_REGO_PHOTO_FRONT = 'DETAILS_REGO_PHOTO_FRONT',
  DETAILS_VEHICLE_ASSET_BACK = 'DETAILS_VEHICLE_ASSET_BACK',
  DETAILS_VEHICLE_ASSET_FRONT = 'DETAILS_VEHICLE_ASSET_FRONT',
  DETAILS_VEHICLE_INTERNAL_FRONT = 'DETAILS_VEHICLE_INTERNAL_FRONT',
  DETAILS_VEHICLE_INTERNAL_BACK = 'DETAILS_VEHICLE_INTERNAL_BACK',
  DETAILS_VEHICLE_INTERNAL_BOOT = 'DETAILS_VEHICLE_INTERNAL_BOOT',
  DETAILS_VEHICLE_INTERNAL_LIVING_AREA = 'DETAILS_VEHICLE_INTERNAL_LIVING_AREA',
  DETAILS_VEHICLE_INTERNAL_KITCHEN = 'DETAILS_VEHICLE_INTERNAL_KITCHEN',
  DETAILS_VEHICLE_INTERNAL_SLEEPING_AREA = 'DETAILS_VEHICLE_INTERNAL_SLEEPING_AREA',
  DETAILS_VEHICLE_OPERATING_HOURS = 'DETAILS_VEHICLE_OPERATING_HOURS',
  DETAILS_VEHICLE_DRIVER_SIDE = 'DETAILS_VEHICLE_DRIVER_SIDE',
  DETAILS_VEHICLE_ODOMETER = 'DETAILS_VEHICLE_ODOMETER',
  DETAILS_VEHICLE_PASSENGER_SIDE = 'DETAILS_VEHICLE_PASSENGER_SIDE',
  DETAILS_VEHICLE_PLATE = 'VEHICLE_PLATE',
  DETAILS_VEHICLE_VIN = 'VEHICLE_VIN',
  DETAILS_MARINE_HIN = 'MARINE_HIN',
  DETAILS_MARINE_REGO_NUMBER = 'MARINE_REGO_NUMBER',
  DETAILS_MARINE_REGO_CERT = 'MARINE_REGO_CERT',
  DETAILS_MARINE_FRONT = 'DETAILS_MARINE_FRONT',
  DETAILS_MARINE_BACK = 'DETAILS_MARINE_BACK',
  DETAILS_MARINE_LEFT = 'DETAILS_MARINE_LEFT',
  DETAILS_MARINE_RIGHT = 'DETAILS_MARINE_RIGHT',
  DETAILS_VEHICLE_PHOTO = 'VEHICLE_PHOTO'
}
export enum NevdisSecurityCheckEnum {
  NEVDIS_SECURITY_RAV = 'rav',
  NEVDIS_SECURITY_PPSR = 'ppsr',
  NEVDIS_SECURITY_REGISTRATION = 'registration',
  NEVDIS_SECURITY_STOLEN = 'stolen',
  NEVDIS_SECURITY_WRITTEN_OFF = 'writtenOff',
  NEVDIS_SECURITY_AUTO_GRAB = 'autoGrabData',
  NEVDIS_SECURITY_VIN = 'vin',
  NEVDIS_SECURITY_PHOTO = 'vehiclePhotos',
  NEVDIS_SECURITY_PHOTO_QUALITY = 'vehiclePhotosQuality',
  NEVDIS_SECURITY_PHOTO_AUTHENTICITY = 'vehiclePhotosAuthenticity',
  NEVDIS_SECURITY_DATA_EDITS = 'dataEdits'
}
export enum RegoSecurityCheckEnum {
  REGO_SECURITY_AUTHENTICITY = 'registrationAuthenticity',
  REGO_SECURITY_EXPIRY = 'expiry',
  REGO_SECURITY_DATA_EDIT = 'regoCertificate'
}
export enum BankSecurityCheckEnum {
  BANK_SECURITY_AUTHENTICITY = 'bankAuthenticity',
  BANK_SECURITY_DATA_EDIT = 'bankStatement',
  BANK_STATEMENT_ADDRESS = 'BANK_STATEMENT_ADDRESS'
}
export enum InspectionBankSection {
  BANK_STATEMENTS = 'Statement Header',
  bankAuthenticity = 'Authenticity',
  bankStatement = 'Data Edit',
  BANK_STATEMENT_ADDRESS = 'Match Rego Cert. Address'
}
export enum VehiclePhoneMappings {
  'ASSET_FRONT' = 1,
  'ASSET_RIGHT' = 2,
  'ASSET_LEFT' = 3,
  'ASSET_BACK' = 4
}
export enum MarinePhoneMappings {
  'MARINE_FRONT' = 1,
  'MARINE_RIGHT' = 2,
  'MARINE_LEFT' = 3,
  'MARINE_BACK' = 4
}
export enum InspectionRoadworthyCertSection {
  ROADWORTHY_CERT = 'Roadworthy / Safety Certificate',
  SAFETY_CERT = 'Safety Certificate'
}
export enum InspectionPayoutLetterSection {
  PAYOUT_LETTER = 'Payout Letter'
}
export enum InspectionOwnershipProofSection {
  OWNERSHIP_PROOF = 'Proof of ownership'
}
export type DocumentType =
  | InspectionDriverLicenseSection
  | InspectionVehicleDetailsSection
  | InspectionRegoPapersSection
  | InspectionRoadworthyCertSection
  | InspectionBankSection
  | InspectionPayoutLetterSection
  | InspectionOwnershipProofSection;
export type DocumentFormType =
  | DocumentFormEnum.DETAILS_DRIVER_LICENSE_FRONT
  | DocumentFormEnum.DETAILS_DRIVER_LICENSE_BACK
  | DocumentFormEnum.DETAILS_DRIVER_LICENSE_SELFIE
  | DocumentFormEnum.DETAILS_DRIVER_LICENSE_AUTHENTICITY
  | DocumentFormEnum.DETAILS_DRIVER_LICENSE_EXPIRY
  | DocumentFormEnum.DETAILS_DRIVER_LICENSE_DATA_EDIT
  | DocumentFormEnum.DETAILS_DRIVER_LICENSE_FACE_MATCH
  | DocumentFormEnum.DETAILS_DRIVER_LICENSE_LIVENESS
  | DocumentFormEnum.DETAILS_DRIVER_LICENSE_OFFICIAL_SOURCE
  | DocumentFormEnum.DETAILS_BANK
  | DocumentFormEnum.DETAILS_CERTIFICATE
  | DocumentFormEnum.DETAILS_REGO_PHOTO_BACK
  | DocumentFormEnum.DETAILS_REGO_PHOTO_FRONT
  | DocumentFormEnum.DETAILS_VEHICLE_ASSET_BACK
  | DocumentFormEnum.DETAILS_VEHICLE_ASSET_FRONT
  | DocumentFormEnum.DETAILS_VEHICLE_DRIVER_SIDE
  | DocumentFormEnum.DETAILS_VEHICLE_INTERNAL_FRONT
  | DocumentFormEnum.DETAILS_VEHICLE_INTERNAL_BACK
  | DocumentFormEnum.DETAILS_VEHICLE_INTERNAL_BOOT
  | DocumentFormEnum.DETAILS_VEHICLE_INTERNAL_LIVING_AREA
  | DocumentFormEnum.DETAILS_VEHICLE_INTERNAL_KITCHEN
  | DocumentFormEnum.DETAILS_VEHICLE_INTERNAL_SLEEPING_AREA
  | DocumentFormEnum.DETAILS_VEHICLE_ODOMETER
  | DocumentFormEnum.DETAILS_VEHICLE_PASSENGER_SIDE
  | DocumentFormEnum.DETAILS_VEHICLE_PLATE
  | DocumentFormEnum.DETAILS_VEHICLE_VIN
  | DocumentFormEnum.DETAILS_MARINE_HIN
  | DocumentFormEnum.DETAILS_MARINE_REGO_NUMBER
  | DocumentFormEnum.DETAILS_MARINE_REGO_CERT
  | DocumentFormEnum.DETAILS_MARINE_FRONT
  | DocumentFormEnum.DETAILS_MARINE_BACK
  | DocumentFormEnum.DETAILS_MARINE_LEFT
  | DocumentFormEnum.DETAILS_MARINE_RIGHT
  | DocumentFormEnum.DETAILS_VEHICLE_PHOTO
  | DocumentFormEnum.DETAILS_PAYOUT_LETTER
  | DocumentFormEnum.DETAILS_OWNERSHIP_PROOF
  | DocumentFormEnum.DETAILS_VEHICLE_OPERATING_HOURS
  | NevdisSecurityCheckEnum.NEVDIS_SECURITY_RAV
  | NevdisSecurityCheckEnum.NEVDIS_SECURITY_PPSR
  | NevdisSecurityCheckEnum.NEVDIS_SECURITY_REGISTRATION
  | NevdisSecurityCheckEnum.NEVDIS_SECURITY_STOLEN
  | NevdisSecurityCheckEnum.NEVDIS_SECURITY_WRITTEN_OFF
  | NevdisSecurityCheckEnum.NEVDIS_SECURITY_AUTO_GRAB
  | NevdisSecurityCheckEnum.NEVDIS_SECURITY_VIN
  | NevdisSecurityCheckEnum.NEVDIS_SECURITY_PHOTO
  | NevdisSecurityCheckEnum.NEVDIS_SECURITY_DATA_EDITS
  | RegoSecurityCheckEnum.REGO_SECURITY_AUTHENTICITY
  | RegoSecurityCheckEnum.REGO_SECURITY_EXPIRY
  | BankSecurityCheckEnum.BANK_SECURITY_AUTHENTICITY
  | BankSecurityCheckEnum.BANK_SECURITY_DATA_EDIT
  | BankSecurityCheckEnum.BANK_STATEMENT_ADDRESS
  | RegoSecurityCheckEnum.REGO_SECURITY_DATA_EDIT;
